import { CompositeSegmentOperation, l } from 'constants/common';

const SegmentItemsConfig = {
    firstEnableDropItems: 1,
    enableDropHere: { enableDropHere: true },
};

const SegmentContainerConfig = {
    exportList: [
        { label: 'CSV', value: 1 },
        { label: 'XLS', value: 2 },
    ],
    defaultColumnsReport: [
        { Id: 76 },
        { Id: 75 },
        { Id: 74 },
        { Id: 73 },
        { Id: 53 },
        { Id: 42 },
        { Id: 40 },
        { Id: 38 },
    ],
    minSegmentsCount: 2,
    radioGroupOptions: [
        { label: l.Union, value: CompositeSegmentOperation.Union, icon: 'bc-icon-union' },
        {
            label: l.Intersect,
            value: CompositeSegmentOperation.Intersect,
            icon: 'bc-icon-intersect',
        },
        {
            label: l.Difference,
            value: CompositeSegmentOperation.Difference,
            icon: 'bc-icon-difference',
            svgIcon: (
                <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24">
                    <path d="M16.5 6.5h-5.75a4.25 4.25 0 0 0-4.25 4.25v5.75H5.25A3.25 3.25 0 0 1 2 13.25v-8A3.25 3.25 0 0 1 5.25 2h8a3.25 3.25 0 0 1 3.25 3.25z" />
                    <path d="M22 18.75A3.25 3.25 0 0 1 18.75 22h-8a3.25 3.25 0 0 1-3.25-3.25v-8a3.25 3.25 0 0 1 3.25-3.25h8A3.25 3.25 0 0 1 22 10.75zm-3.25 1.75a1.75 1.75 0 0 0 1.75-1.75v-8A1.75 1.75 0 0 0 18.75 9h-8A1.75 1.75 0 0 0 9 10.75v8c0 .966.784 1.75 1.75 1.75z" />
                </svg>
            ),
        },
    ],
    tootltips: {
        [CompositeSegmentOperation.Union]: 'TooltipUnion',
        [CompositeSegmentOperation.Intersect]: 'TooltipIntersect',
        [CompositeSegmentOperation.Difference]: 'TooltipDifference',
    },
};

export { SegmentItemsConfig, SegmentContainerConfig };
